import { useMutation } from '@tanstack/react-query';
import type {
  ResendAllConnectionPensioenbijEventsArgs,
  ResendAllEmployeePensioenbijEventsArgs,
  ResendAllPensioenbijEventsArgs,
} from '../../../Domain/Tools/Services';
import { toolsServices } from '../../../Domain/Tools/Services';

export type ResendAllPensioenbijMutationArgs =
  | ({ scope: 'dashboard' } & ResendAllPensioenbijEventsArgs)
  | ({ scope: 'connection' } & ResendAllConnectionPensioenbijEventsArgs)
  | ({ scope: 'employee' } & ResendAllEmployeePensioenbijEventsArgs);

const mutationFn = (args: ResendAllPensioenbijMutationArgs) => {
  if (args.scope === 'connection') {
    const { scope, ...rest } = args;
    return toolsServices.resendAllConnectionPensioenbijEvents(rest);
  }

  if (args.scope === 'employee') {
    const { scope, ...rest } = args;
    return toolsServices.resendAllEmployeePensioenbijEvents(rest);
  }

  const { scope, ...rest } = args;
  return toolsServices.resendAllPensioenbijEvents(rest);
};

export const useResendAllPensioenbijMutation = () => {
  return useMutation<unknown, unknown, ResendAllPensioenbijMutationArgs>(mutationFn);
};
